<template>
    <div>
        <!--
<div v-if="getFirst" class="elementContainer">
<Element v-if="getFirst" :first="true" :item="getFirst" :isArchive="false" :live="store.live"></Element>
</div>
-->
        <!-- <div v-if="!store.live" id="scheduleElement"> -->
        <!--     <p> -->
        <!--         We are back on air {{ getUpcomingItem }}. Add shows from the -->
        <!--         archive to our public playlist or become a Montez Press Radio -->
        <!--         Supporter and get instant access to our entire, evergrowing -->
        <!--         archive. -->
        <!--     </p> -->
        <!-- </div> -->

        <!-- <div v-if="!store.live && getRest.length" class="seperator"> -->
        <!--     Next up on the Public Playlist -->
        <!-- </div> -->
        <!-- <div v-else-if="store.liveFuture.length" class="seperator"> -->
        <!--     Next Live Shows -->
        <!-- </div> -->

        <!-- <div class="elementContainer" id="playlist"> -->
        <!--     <Element -->
        <!--         v-for="(item, index) in getRest" -->
        <!--         :live="store.live" -->
        <!--         :first="false" -->
        <!--         :key="item.id" -->
        <!--         :item="item" -->
        <!--         :index="index" -->
        <!--         :isArchive="false" -->
        <!--     ></Element> -->
        <!-- </div> -->

        <router-link id="series" v-if="series.slug" :to="{ name: 'seriesDetail', params: { slug: series.slug } }">

            <div class="title seperator">
                <div>{{ series.title }}</div>
                <div>{{ getSeriesDate(series.earliest_item, series.latest_item) }}</div>
            </div>

            <div id="seriesImage" :class="{ desktop: $mq != 'sm' }">
                <img :src="series.thumbnail" alt="" />
            </div>



        </router-link>

        <div v-if="picks.length" class="seperator">MPR Picks</div>
        <div v-if="picks.length" class="elementContainer">
            <Element v-for="(item, index) in picks" :live="store.live" :first="false" :key="item.id" :item="item"
                :index="index" :isArchive="false" isPick="true"></Element>
        </div>

        <div v-if="store.streams.length" class="seperator">Channels</div>

        <div v-if="store.streams.length" id="streams">
            <router-link v-for="stream in store.streams" :to="{ name: 'streamDetail', params: { slug: stream.slug } }">
                <div class="stream">
                    <img :src="stream.small_thumbnail" alt="" />
                    <img id="play" v-if="isPlaying(stream.pk, stream.type)" @click.prevent.stop="setPause" :src="isHovering == stream.pk
                        ? '/static/new_icons/pause-player_hover.svg'
                        : '/static/icons/pause-player.svg'
                        " @mouseover="isHovering = stream.pk" @mouseout="isHovering = false" />

                    <img id="play" v-else @click.prevent.stop="setPlay(stream)" :src="isHovering == stream.pk
                        ? '/static/new_icons/play-player-large_hover.svg'
                        : '/static/icons/play-player-large.svg'
                        " @mouseover="isHovering = stream.pk" @mouseout="isHovering = false" />
                    <p class="streamTitle">{{ stream.title }}</p>
                </div>
            </router-link>
        </div>

        <div class="seperator playlist">
            <span> Public Playlist </span>
            <router-link :to="{ name: 'archive' }" v-if="$mq == 'sm'" id="archiveLink">
                <span id="archiveText">Add shows from the Archive</span>

                <img :src="archiveLinkHover
                    ? '/static/new_icons/add_hover.svg'
                    : '/static/icons/add.svg'
                    " id="archiveLink" @click="archiveLinkHover = false" @mouseover="archiveLinkHover = true"
                    @mouseout="archiveLinkHover = false" />
            </router-link>
        </div>

        <div id="playlist">
            <template v-for="(item, index) in store.playlist.items">
                <router-link :to="{ name: 'detail', params: { id: item.pk } }" v-if="index == 0"
                    class="activeItem playlistItem" :class="{ desktop: $mq != 'sm' }">
                    <img :src="item.small_thumbnail" alt="" />
                    <img id="play" v-if="isPlaying(store.playlist.pk, store.playlist.type)"
                        @click.prevent.stop="setPause" :src="isHovering == 'playlist'
                            ? '/static/new_icons/pause-player_hover.svg'
                            : '/static/icons/pause-player.svg'
                            " @mouseover="isHovering = 'playlist'" @mouseout="isHovering = false" />

                    <img id="play" v-else @click.prevent.stop="setPlay(store.playlist)" :src="isHovering == 'playlist'
                        ? '/static/new_icons/play-player-large_hover.svg'
                        : '/static/icons/play-player-large.svg'
                        " @mouseover="isHovering = 'playlist'" @mouseout="isHovering = false" />
                    <!-- <div -->
                    <!--     v-if=" -->
                    <!--         store.privatePlayerItem.type == 'playlist' && -->
                    <!--             store.privatePlayerStatus == 'unpaused' -->
                    <!--     " -->
                    <!-- > -->
                    <!--     PAUSE -->
                    <!-- </div> -->
                    <div v-if="$mq == 'sm'" id="title" class="activeItem">
                        <span>{{ item.artist }}</span>
                        <span>{{ item.title }}</span>
                    </div>
                    <div v-else id="title" class="activeItem">
                        <span v-if="item.artist && item.title">{{ item.artist }}: {{ item.title }}</span>
                        <span v-else-if="item.artist && !item.title">{{
                            item.artist
                            }}</span>
                        <span v-else>{{ item.title }}</span>
                    </div>

                    <router-link :to="{ name: 'archive' }" v-if="$mq != 'sm'" id="archiveLink">
                        <span id="archiveText">
                            Add shows from the Archive
                        </span>

                        <img :src="archiveLinkHover
                            ? '/static/new_icons/add_hover.svg'
                            : '/static/icons/add.svg'
                            " id="archiveLink" @click="archiveLinkHover = false" @mouseover="archiveLinkHover = true"
                            @mouseout="archiveLinkHover = false" />
                    </router-link>
                </router-link>
                <router-link :to="{ name: 'detail', params: { id: item.pk } }" v-else class="playlistItem"
                    :class="{ desktop: $mq != 'sm' }">
                    <img :src="item.small_thumbnail" alt="" />
                    <div id="title" class="mobile" v-if="$mq == 'sm'">
                        <span>
                            {{ item.title }}
                        </span>
                        <span>
                            {{ item.artist }}
                        </span>
                        <span id="titleLocation">
                            <span class="playlistDate" v-html="formatDate(item.start_time)"></span>
                            <span v-if="item.venue">{{ item.venue }}</span>
                            <span v-if="item.city">{{ item.city }}</span>
                        </span>
                    </div>
                    <div v-else id="title" class="desktop">
                        <span class="playlistDate" v-html="formatDate(item.start_time)"></span>
                        <span v-html="item.artist"> </span>
                        <span v-html="item.title"> </span>
                        <span>{{ item.venue }}</span>
                        <span>{{ item.city }}</span>
                        <span v-html="formatLastAdded(item.last_added)" class="remain"></span>
                    </div>
                    <div v-html="formatLastAdded(item.last_added)" v-if="$mq == 'sm'" class="remain"></div>
                </router-link>
            </template>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
import { store } from "../store";
import { DateTime, Duration } from "luxon";
import Element from "./Element";
import axios from "axios";
import Footer from "./Footer.vue";
import { getSeriesDate } from "../composables/date.js"

export default {
    name: "Home",
    components: {
        Element,
        Footer,
    },
    data() {
        return {
            store: store,
            picks: [],
            isHovering: false,
            archiveLinkHover: false,
            series: { slug: '' },
            getSeriesDate: getSeriesDate
        };
    },
    computed: {
        getUpcomingItem: function () {
            if (this.store.liveList.length > 0) {
                //return 'at ' + this.list[0].start_time;
                return (
                    "on " +
                    DateTime.fromISO(this.store.liveList[0].start_time, {
                        zone: "utc",
                    })
                        .toLocal()
                        .toFormat("cccc MMMM d")
                );
            } else {
                return "again soon";
            }
        },
        // getFirst() {
        //     if (this.store.live) {
        //         if (this.store.liveTrack) {
        //             return this.store.liveTrack;
        //         } else {
        //             return false;
        //         }
        //     } else {
        //         if (this.store.playlist.length) {
        //             return this.store.playingItem;
        //         } else {
        //             return false;
        //         }
        //     }
        // }
        // getRest() {
        //     if (this.store.live) {
        //         if (this.store.liveFuture.length) {
        //             let restList = this.store.liveFuture;
        //             return restList;
        //         } else {
        //             return [];
        //         }
        //     } else {
        //         if (this.store.playlist.length) {
        //             let restList = this.store.playlist.slice(
        //                 this.store.playlist.indexOf(this.store.playingItem) + 1
        //             );
        //             //let restList = this.store.playlist;
        //             return restList;
        //         } else {
        //             return [];
        //         }
        //     }
        // }
    },
    methods: {
        formatDate(date) {
            return DateTime.fromISO(date)
                .setLocale("en-US")
                .toFormat("MM/dd/yy");
        },
        setPause() {
            this.store.privatePlayerStatus = "paused";
            this.pauseHover = false;
        },

        isPlaying(pk, type) {
            if (
                store.privatePlayerItem.type == type &&
                store.privatePlayerItem.pk == pk &&
                store.privatePlayerStatus == "playing"
            ) {
                return true;
            }
        },
        formatLastAdded(date) {
            let remaining = DateTime.utc().diff(
                DateTime.fromISO(date, { zone: "utc" }),
                "minutes"
            );
            let unit = "min";
            if (remaining.toObject().minutes > 59) {
                remaining = DateTime.utc().diff(
                    DateTime.fromISO(date, { zone: "utc" }),
                    "hours"
                );
                unit = "h";
                if (remaining.toObject().hours > 23) {
                    remaining = DateTime.utc().diff(
                        DateTime.fromISO(date, { zone: "utc" }),
                        "days"
                    );
                    unit = "d";
                }
            }
            let datestring;
            if (this.$mq == "sm") {
                datestring =
                    "Added <br>" +
                    Math.floor(Object.values(remaining.toObject())[0]) +
                    " " +
                    unit +
                    " ago";
            } else {
                datestring =
                    "Added " +
                    Math.floor(Object.values(remaining.toObject())[0]) +
                    " " +
                    unit +
                    " ago";
            }
            return datestring;
        },

        setPlay(item) {
            this.store.privatePlayerItem = item;
            this.store.privatePlayerItemID = item.pk;
            this.store.privatePlayerVisible = true;
            this.store.privatePlayerChanged = true;
            // this.store.privatePlayerStatus = "paused";
            this.store.privatePlayerStatus = "unpaused";
        },
    },
    mounted: function () {
        let myself = this;
        axios.get("/api/get-picks").then((response) => {
            this.picks = response.data.items;
        });
        axios.get("/api/series-latest").then((response) => {
            this.series = response.data.series;
        });
        //axios
        //.get('/api/get-streams')
        //.then(response => {
        //this.streams = response.data.items;
        //})
    },
};
</script>

<style scoped>
.seperator {
    padding: 0.7rem 1rem 0.7rem;
    border-top: 1px solid black;
}

#archiveLink {
    font-size: 12px;
    font-family: "Montez Small";
    display: flex;
    align-items: center;
    gap: 1rem;
}

.seperator.playlist {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

@keyframes blink-animation {
    to {
        visibility: hidden;
    }
}

@-webkit-keyframes blink-animation {
    to {
        visibility: hidden;
    }
}

.blink {
    margin-left: 0.7rem;
    animation: blink-animation 2s steps(2, start) infinite;
    -webkit-animation: blink-animation 2s steps(2, start) infinite;
}

.blink.mobile {
    font-family: "Montez Small";
    font-size: 1rem;
}

#scheduleElement {
    background-color: #fcfac4;
    /*min-height: calc(100vw - 2rem);*/
    height: auto;
    min-width: calc(100vw - 4rem);
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /*box-shadow: inset 0px 0px 2rem 1rem white*/
}

#scheduleElement p {
    text-align: center;
    width: calc(100% - 4rem);
}

@media only screen and (min-width: 738px) {
    #scheduleElement {
        /*min-height: calc(50vw - 2rem);*/
        /*min-width: calc(50vw - 2rem);*/
        /*margin: 0.5rem 0;*/
    }
}

@media only screen and (min-width: 1101px) {
    #scheduleElement {
        /*min-height: calc(33.3vw - 2rem);*/
        /*min-width: calc(66.6vw - 2rem);*/
    }

    #scheduleElement p {
        width: 75%;
    }
}

@media only screen and (min-width: 1440px) {
    #scheduleElement {
        /*min-height: calc(25vw - 3rem);*/
        /*min-width: calc(75vw - 2rem);*/
    }
}

@media only screen and (min-width: 1900px) {
    #scheduleElement {
        /*min-height: calc(20vw - 2rem);*/
        /*min-width: calc(80vw - 2rem);*/
    }
}

#streams {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(350px, 100%), 1fr));
    gap: 1rem;
    margin: 1rem 1rem 2rem;
}

.stream {
    border: 1px solid black;
    display: flex;
    gap: 1rem;
    padding: 1rem;
    align-items: center;
}

.stream>p {
    margin: 0;
}

.stream>img {
    width: 51px;
    height: 51px;
    object-fit: cover;
}

.streamTitle {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.playlistItem {
    padding: 0.5rem 1rem;
    display: flex;
    gap: 1rem;
    align-items: center;
    white-space: nowrap;
    color: grey;
    font-size: 12px;
    font-family: "Montez Small";
    line-height: initial;
}

.playlistItem:last-child {
    padding-bottom: 2rem;
}

.playlistItem.desktop {
    font-size: initial;
    font-family: "Montez Large";
    padding: 1rem;
    border-top: 1px solid lightgrey;
}

.remain {
    flex-shrink: 0;
    font-size: 12px;
    font-family: "Montez Small";
    text-align: right;
}

.playlistItem>.title {
    flex-grow: 1;
}

.playlistItem>img {
    flex-shrink: 0;
    object-fit: cover;
    height: 51px;
    width: 51px;
}

.playlistItem.desktop>img {
    height: 26px;
    width: 26px;
}

.playlistItem.activeItem {
    color: black;
    border-top: none;
}

.playlistItem.activeItem>img {
    height: 51px;
    width: 51px;
}

#play,
#pause {
    cursor: pointer;
    height: 3rem;
    width: 3rem;
    object-fit: cover;
}

#archiveLink {
    height: 1.7rem;
}

#title {
    flex-grow: 1;
    overflow: hidden;
}

#title>* {
    overflow: hidden;
    text-overflow: ellipsis;
}

#title.mobile {
    display: flex;
    flex-direction: column;
}

#title.desktop {
    display: grid;
    gap: 1rem;
    grid-template-columns: auto 2fr 2fr 1fr 1fr 1fr;
}

#titleLocation {
    display: flex;
    gap: 1rem;
}

#title.activeItem {
    display: flex;
    flex-direction: column;
}

.playlistDate {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "case" on;
}

#archiveText {
    white-space: nowrap;
}

#seriesImage {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}

#seriesImage.desktop {
    padding: 50px;
}

#seriesImage>img {
    /* width: min(750px, 100%); */
    width: 100%;
    max-width: 750px;

}
</style>
